import { Pipe, PipeTransform } from '@angular/core';
import { NamingConventionItemGridData } from '@project-setup/models/grid';
import { NamingConventionType } from '@shared/enums';
import { NamingConventionItem } from '@shared/models';
import { NamingConventionDprDetails } from '@shared/models/dpr';
import { NamingConventionService } from '@shared/services/dpr';

@Pipe({
  name: 'customFilename',
})
export class CustomFilenamePipe implements PipeTransform {
  constructor(private namingConventionService: NamingConventionService) {}

  transform(
    namingConventionType: NamingConventionType,
    namingConventionItemList:
      | NamingConventionItemGridData[]
      | NamingConventionItem[],
    filenameSampleDetails: NamingConventionDprDetails,
    placeholderName?: string
  ): string {
    return this.namingConventionService.getCustomFileName(
      namingConventionType,
      namingConventionItemList as NamingConventionItem[],
      filenameSampleDetails,
      placeholderName
    );
  }
}
